import Vue from 'vue'
import Router from 'vue-router'
import OidcCallback from '@/views/OidcCallback'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import store from '@/store/store'
import TeaserMatchService from '@/services/TeaserMatchService'

import RunThrough from '@/views/RunThrough'
import Home from '@/views/Home'
import MessageCenter from '@/views/MessageCenter'
import Fair from '@/views/Fair'
import FairDetail from '@/views/FairDetail'
import Logout from '@/views/Logout'
import PastFair from '@/views/PastFair'
import PastFairWrapper from '@/views/PastFairWrapper'
import FairInsurance from '@/views/FairInsurance'
import Imprint from '@/views/Imprint'
import DataProtection from '@/views/DataProtection'
import AdminHome from '@/views/Admin/Home'
import AdminFairOverview from '@/views/Admin/Fair/Overview'
import AdminFairDetail from '@/views/Admin/Fair/Detail'
import AdminAdvertisingOverview from '@/views/Admin/Advertising/Overview'
import AdminAdvertisingTeaser from '@/views/Admin/Advertising/Teaser'
import AdminAdvertisingFairWallOverview from '@/views/Admin/Advertising/FairWall/Overview.vue'
import AdminAdvertisingFairWallCreate from '@/views/Admin/Advertising/FairWall/FairWall.vue'
import AdminCoredataOverview from '@/views/Admin/Coredata/Overview'
import AdminCoredataTaskdefinition from '@/views/Admin/Coredata/Taskdefinition'
import AdminCoredataTaskTitleOverview from '@/views/Admin/Coredata/TaskTitle/Overview'
import AdminCoredataTaskTitleForm from '@/views/Admin/Coredata/TaskTitle/TaskTitle'
import AdminCoredataBoothServiceOverview from '@/views/Admin/Coredata/BoothService/Overview'
import AdminCoredataBoothServiceForm from '@/views/Admin/Coredata/BoothService/BoothService'
import AdminCoredataFairSeriesOverview from '@/views/Admin/Coredata/FairSeries/Overview'
import AdminCoredataFairSeriesForm from '@/views/Admin/Coredata/FairSeries/FairSeries'
import AdminCoreDataHeaderDefinitionOverview from '@/views/Admin/Coredata/HeaderDefinitions/Overview'
import AdminCoreDataHeaderDefinitionForm from '@/views/Admin/Coredata/HeaderDefinitions/Headerdefinition'
import AdminCoredataServiceBlacklistOverview from '@/views/Admin/Coredata/ServiceBlacklist/Overview'
import AdminCoredataServiceBlacklistForm from '@/views/Admin/Coredata/ServiceBlacklist/Blacklist'

// for detecting browser back button
window.popStateDetected = false
window.addEventListener('popstate', () => {
  window.popStateDetected = true
})

Vue.use(Router)

const routes = [
  {
    name: 'Home',
    path: '/',
    component: Home
  },
  {
    name: 'Profile',
    path: '/profile',
    beforeEnter(to, from, next) {
      window.location =
        'https://' +
        (process.env.VUE_APP_OIDC_DOMAIN ||
          process.env.VUE_APP_OIDC_DOMAIN_BUILDIN) +
        '/auth/realms/bernexpo/account'
    }
  },
  {
    name: 'Logout',
    path: '/logout',
    component: Logout
  },
  {
    name: 'Fair',
    path: '/fair',
    component: Fair,
    children: [
      {
        name: 'FairDetail',
        path: ':code/:booth',
        component: FairDetail,
        children: []
      }
    ]
  },
  {
    name: 'Insurance',
    path: '/fair/:code/:booth/insurance',
    beforeEnter(to, from, next) {
      store.dispatch('ui/setSpecialHeader', true)
      next()
    },
    component: FairInsurance
  },
  {
    name: 'PastFairWrapper',
    path: '/pastfairs',
    component: PastFairWrapper,
    children: [
      {
        name: 'PastFairs',
        path: ':series/:fair',
        component: PastFair
      }
    ]
  },
  {
    name: 'Imprint',
    path: '/imprint',
    component: Imprint
  },
  {
    name: 'DataProtection',
    path: '/dataprotection',
    component: DataProtection
  },
  {
    name: 'AdminHome',
    path: '/admin',
    component: AdminHome,
    redirect: {
      name: 'AdminFairOverview'
    },
    meta: {
      requiresAdmin: true
    },
    children: [
      {
        name: 'AdminFair',
        path: '/admin/fair',
        component: RunThrough,
        redirect: {
          name: 'AdminFairOverview'
        },
        meta: {
          requiresAdmin: true
        },
        children: [
          {
            name: 'AdminFairOverview',
            path: 'overview',
            component: AdminFairOverview,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminFairCreate',
            path: 'create',
            component: AdminFairDetail,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminFairEdit',
            path: ':id',
            component: AdminFairDetail,
            meta: {
              requiresAdmin: true
            }
          }
        ]
      },
      {
        name: 'AdminAdvertising',
        path: '/admin/advertising',
        component: RunThrough,
        redirect: {
          name: 'AdminAdvertisingOverview'
        },
        meta: {
          requiresAdmin: true
        },
        children: [
          {
            name: 'AdminAdvertisingOverview',
            path: '/admin/advertising/overview',
            component: AdminAdvertisingOverview,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminAdvertisingCreate',
            path: '/admin/advertising/create',
            component: AdminAdvertisingTeaser,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminAdvertisingEdit',
            path: '/admin/advertising/edit/:id',
            component: AdminAdvertisingTeaser,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminAdvertisingFairWallOverview',
            path: '/admin/advertising/fairwallentries',
            component: AdminAdvertisingFairWallOverview,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminAdvertisingFairWallCreate',
            path: '/admin/advertising/createfairwall',
            component: AdminAdvertisingFairWallCreate,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminAdvertisingFairWallEdit',
            path: '/admin/advertising/editfairwall/:id',
            component: AdminAdvertisingFairWallCreate,
            meta: {
              requiresAdmin: true
            }
          }
        ]
      },
      {
        name: 'AdminCoredata',
        path: '/admin/coredata',
        component: RunThrough,
        redirect: {
          name: 'AdminCoredataOverview'
        },
        meta: {
          requiresAdmin: true
        },
        children: [
          {
            name: 'AdminCoredataOverview',
            path: '/admin/coredata/overview',
            component: AdminCoredataOverview,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataCreate',
            path: '/admin/coredata/create',
            component: AdminCoredataTaskdefinition,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataEdit',
            path: '/admin/coredata/edit/:id',
            props: true,
            component: AdminCoredataTaskdefinition,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataFairSeriesOverview',
            path: '/admin/coredata/fairseries',
            component: AdminCoredataFairSeriesOverview,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoreDataFairSeriesCreate',
            path: '/admin/coredata/fairseriesform',
            component: AdminCoredataFairSeriesForm,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoreDataFairSeriesEdit',
            path: '/admin/coredata/fairseriesform/:id',
            component: AdminCoredataFairSeriesForm,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataTaskTitleOverview',
            path: '/admin/coredata/tasktitles',
            component: AdminCoredataTaskTitleOverview,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataTaskTitleCreate',
            path: '/admin/coredata//admin/coredate/tasktitleform',
            component: AdminCoredataTaskTitleForm,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataTaskTitleEdit',
            path: '/admin/coredata/tasktitleform/:id',
            props: true,
            component: AdminCoredataTaskTitleForm,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataBoothServicesOverview',
            path: '/admin/coredata/boothservice',
            component: AdminCoredataBoothServiceOverview,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataBoothServiceCreate',
            path: '/admin/coredata//admin/coredate/boothserviceform',
            component: AdminCoredataBoothServiceForm,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataBoothServiceEdit',
            path: '/admin/coredata/boothserviceform/:id',
            props: true,
            component: AdminCoredataBoothServiceForm,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataBlacklistOverview',
            path: '/admin/coredata/blacklist',
            component: AdminCoredataServiceBlacklistOverview,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataBlacklistCreate',
            path: '/admin/coredata//admin/coredate/blacklistform',
            component: AdminCoredataServiceBlacklistForm,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataBlacklistEdit',
            path: '/admin/coredata/blacklistform/:id',
            props: true,
            component: AdminCoredataServiceBlacklistForm,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoreDataHeaderDefinitionOverview',
            path: '/admin/coredata/headerdefinitions',
            component: AdminCoreDataHeaderDefinitionOverview,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataHeaderDefinitionCreate',
            path: '/admin/coredata/headerform/create',
            component: AdminCoreDataHeaderDefinitionForm,
            meta: {
              requiresAdmin: true
            }
          },
          {
            name: 'AdminCoredataHeaderDefinitionEdit',
            path: '/admin/coredata/headerform/edit/:id',
            props: true,
            component: AdminCoreDataHeaderDefinitionForm,
            meta: {
              requiresAdmin: true
            }
          }
        ]
      }
      // TODO: Reintegrade or remove Marketing Routes
      // {
      //   name: 'AdminMarketingFairwall',
      //   path: 'interest',
      //   component: () => import('./views/AdminMarketingFairwall.vue'),
      //   children: [
      //     {
      //       name: 'TBD1',
      //       path: 'create',
      //       component: RunThrough
      //     },
      //     {
      //       name: 'TBD2',
      //       path: ':id',
      //       component: RunThrough,
      //       props: true
      //     }
      //   ]
      // }
    ]
  },
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/oidc-callback', // Needs to match redirectUri (redirect_uri if you use snake case) in you oidcSettings
    name: 'oidcCallback',
    component: OidcCallback,
    meta: {
      isOidcCallback: true,
      isPublic: true
    }
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.params.booth === 'new') {
      document.getElementById('app').scrollTop = 0
    }
    return { x: 0, y: 0 }
  }
})
router.beforeEach(vuexOidcCreateRouterMiddleware(store))
router.beforeEach((to, from, next) => {
  const IsItABackButton = window.popStateDetected
  window.popStateDetected = false
  if (IsItABackButton) {
    store.commit('ui/setModalStatus', false)
  }
  store.dispatch('ui/setSpecialHeader', false)
  if (to.meta.requiresAdmin) {
    if (store.getters['user/roles'].indexOf('ONESHOP_MANAGER') > -1) {
      next()
    } else {
      next('/')
    }
  } else {
    next()
  }
})
router.beforeEach(TeaserMatchService.checkParams(router, store))

export { router as default, routes }
